/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Size Converter — Bytes, KB, MB, GB, GiB | Toolverse`)
};

const es_ds_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Tamaño de Datos — Bytes, KB, MB, GB, GiB | Toolverse`)
};

const de_ds_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datengrößen-Konverter — Byte, KB, MB, GB, GiB | Toolverse`)
};

const nl_ds_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Size Converter — Bytes, KB, MB, GB, GiB | Toolverse`)
};

const fr_ds_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de taille de données — Octets, KB, MB, GB, GiB | Toolverse`)
};

const it_ds_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di dimensioni dei dati — B, KB, MB, GB, GiB | Toolverse`)
};

const pt_br2_ds_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Tamanho de Dados — Bytes, KB, MB, GB, GiB | Toolverse`)
};

const pt_ds_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Tamanhos de Dados — Bytes, KB, MB, GB, GiB | Toolverse`)
};

const ja_ds_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データサイズ変換ツール — バイト、KB、MB、GB、GiB | Toolverse`)
};

const zh_ds_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据大小转换器 — 字节、KB、MB、GB、GiB | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_meta_title", locale)
	if (locale === "en") return en_ds_meta_title(inputs)
	if (locale === "es") return es_ds_meta_title(inputs)
	if (locale === "de") return de_ds_meta_title(inputs)
	if (locale === "nl") return nl_ds_meta_title(inputs)
	if (locale === "fr") return fr_ds_meta_title(inputs)
	if (locale === "it") return it_ds_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_ds_meta_title(inputs)
	if (locale === "pt") return pt_ds_meta_title(inputs)
	if (locale === "ja") return ja_ds_meta_title(inputs)
	return zh_ds_meta_title(inputs)
};